<template>
  <div class="vip-card">
    <div class="vip-card-title">
      {{ `${vipInfo.type_open_number}${vipInfo.type != 5 ? '个' : ''}${vipInfo.typeName}` }}
    </div>
    <div class="vip-card-content">
      <div class="vip-price">
        <CurrencyNew
          :price="vipInfo.price"
          :priceTwo="true"
          :showFreeText="false"
          :isUnderlineLeft="false"
        ></CurrencyNew>
      </div>
      <span class="vip-open-button" @click="openVip">立即开通</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VipCard',
  props: {
    vipInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    openVip() {
      this.$router.push({
        name: 'OrderConfirm',
        params: { id: this.vipInfo.vip_id },
        query: {
          type: 20,
          type_open_number: this.vipInfo.type_open_number,
          dateLength: this.vipInfo.type,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.vip-card {
  cursor: pointer;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  background: #fff;
  padding-bottom: 4px;

  .vip-card-title {
    padding: 12px 0;
    height: 24px;
    height: 48px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    text-align: center;
    color: #333333;
    line-height: 24px;
    box-sizing: border-box;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  }
  .vip-card-content {
    text-align: center;
    margin: 0 4px 0 4px;
    .vip-price {
      padding-top: 40px;
      height: 50px;
      font-size: 24px;
      font-family: San Francisco Text, San Francisco Text-Semibold;
      font-weight: 600;
      color: #333333;
      .price-wrap {
        display: inline-block;
        ::v-deep.price {
          color: #333333 !important;
          display: inline-block;
          font-size: 36px;
          height: 50px;
          line-height: 50px;
          margin-right: 3px;
        }
        ::v-deep .rmb-svg-new {
          display: inline-block;
          line-height: 45px;
          font-size: 24px;
          vertical-align: top;
        }
      }
      .price {
        display: inline-block;
        font-size: 36px;
        height: 50px;
        line-height: 50px;
      }
      .unit {
        display: inline-block;
        line-height: 40px;
        vertical-align: top;
      }
    }
    .vip-open-button {
      display: inline-block;
      margin: 24px 0 40px 0;
      width: 106px;
      height: 36px;
      opacity: 1;
      background: linear-gradient(90deg, #f4dda8, #f4c56c 100%);
      border-radius: 50px;
      line-height: 36px;

      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: #7c5c2e;
    }
  }
}
.vip-card:hover {
  background: linear-gradient(90deg, #f4dda8, #f4c56c 100%);
  .vip-card-title {
    border: none;
  }
  .vip-card-content {
    background: #fefaed;
    box-shadow: 0px 10px 40px 0px rgba(0, 0, 0, 0.05);
    border-radius: 0 0 4px 4px;
  }
}
</style>
